import React from 'react';

import {
	Container, ModalService, StorageService, TrackingEventNames, TrackingService,
} from '../../features/symphony';

import { SlBlockerModal } from '../../features/shared/public/SlBlockerModal/SlBlockerModal';
import { SlModalIds } from '../shared/constants';
import { IPopUpData, PopUpDataKeys } from '../../features/api/public/abTesting-api';
import { IUserSettingsApi, UserSettingsApi, AppSettingKeys } from '../../features/api/public/user-settings-api';

export interface PrivacyPolicyProps {
	staticData: IPopUpData;
	version: number;
	htmlContent: string;
}
export const PrivacyPolicy:React.FC<PrivacyPolicyProps> = ({ staticData, version, htmlContent }): JSX.Element => {
	const onAccept = (): void => {
		const modalService = Container.take('global', ModalService);
		const storageService = Container.take('global', StorageService);
		const { tracking$ }: any = Container.take('global', TrackingService);

		const hardBlocker: {
			[key: string]: IPopUpData
		} = storageService.load('hardBlocker', 'session');

		const userSettings: IUserSettingsApi = new UserSettingsApi();
		modalService.close(SlModalIds.privacyPolicyModal);

		storageService.save('hardBlocker', {
			...hardBlocker,
			privacyPolicy: version,

		}, 'session');
		const updatedData = {
			version,
			timestamp: Math.floor(Date.now() / 1000),
		};

		userSettings.updateUserSettings([
			{
				key: AppSettingKeys.privacyPolicyVersion,
				value: JSON.stringify(updatedData),
			},
		]).subscribe();

		tracking$.next({
			eventName: TrackingEventNames.slPrivacyPolicyAccept,
			eventParams: {
				action: 'click',
			},
		});
	};

	return staticData ? (
		<SlBlockerModal
			onAccept={onAccept}
			title={staticData.header}
			subtitle={staticData.body}
			pageContent={htmlContent}
			actionButtonText={staticData?.[PopUpDataKeys.acceptButtonText]}
		/>
	) : null;
};
